import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollSlider", "scrollContainer"]

  connect() {
    this.checkOverflow()
    this.resizeObserver = new ResizeObserver(() => this.checkOverflow())
    if (this.hasScrollContainerTarget) {
      this.resizeObserver.observe(this.scrollContainerTarget)
      this.scrollContainerTarget.addEventListener("scroll", this.syncSliderFromScroll)
    }
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
    if (this.hasScrollContainerTarget) {
      this.scrollContainerTarget.removeEventListener("scroll", this.syncSliderFromScroll)
    }
  }

  get scroller() {
    return this.hasScrollContainerTarget ? this.scrollContainerTarget : this.element
  }

  checkOverflow() {
    if (!this.hasScrollSliderTarget) return
    const el = this.scroller
    const isOverflowing = el.scrollWidth > el.clientWidth
    this.scrollSliderTarget.parentElement.classList.toggle("hidden", !isOverflowing)
    this.updateSliderMax()
  }

  updateSliderMax() {
    if (!this.hasScrollSliderTarget) return
    const el = this.scroller
    const maxScroll = el.scrollWidth - el.clientWidth
    this.scrollSliderTarget.max = maxScroll
    this.scrollSliderTarget.value = el.scrollLeft
  }

  syncSliderFromScroll = () => {
    if (!this.hasScrollSliderTarget) return
    const el = this.scroller
    this.scrollSliderTarget.value = el.scrollLeft
  }

  slide(event) {
    const el = this.scroller
    el.scrollLeft = event.target.value
  }
}
